import { Component } from '@angular/core'
import { OrderConfirmationTotalsComponent } from '@spartacus/order/components'
import { OrderFacade } from '@spartacus/order/root'

@Component({
    selector: 'app-custom-order-confirmation-totals',
    templateUrl: './custom-order-confirmation-totals.component.html',
    styleUrls: ['./custom-order-confirmation-totals.component.scss'],
    standalone: false
})
export class CustomOrderConfirmationTotalsComponent extends OrderConfirmationTotalsComponent {
  constructor(protected orderFacade: OrderFacade) {
    super(orderFacade)
  }
}
